import { SignupMenu } from './Signup';

export type AccountMenuProps = {
  content: LayoutContent;
};

export function AccountMenu({ content }: AccountMenuProps) {
  // TODO: verify authentication and render appropriated menu

  return <SignupMenu content={content} />;
}
